import { render, staticRenderFns } from "./deviceInfo.vue?vue&type=template&id=507e571b&scoped=true"
import script from "./deviceInfo.vue?vue&type=script&lang=js"
export * from "./deviceInfo.vue?vue&type=script&lang=js"
import style0 from "./deviceInfo.vue?vue&type=style&index=0&id=507e571b&prod&lang=scss&scoped=true"
import style1 from "./deviceInfo.vue?vue&type=style&index=1&id=507e571b&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507e571b",
  null
  
)

export default component.exports